import { Loader2 } from "lucide-react";

export function PageLoader() {
  return (
    <div className="h-[100vh] w-full flex justify-center items-center">
      <Loader2 className="animate-spin mr-4" />
      Loading...
    </div>
  );
}
